import React, { useEffect, useState } from 'react';
import '../../assests/css/MyProfile.css';
import Header from '../Headers/Header';
import Footer from '../Footers/Footer';
import { useNavigate } from 'react-router-dom';

const ChangePassword = () => {

    const navigate = useNavigate();

    return (
        <div className='myProfile'>
            <div className='edit_profile    '>
                <section className='bg-privacy-policy-top mb-5'>
                    <Header />
                    <div className='container px-5'>
                        <div className='row px-3'>
                            <div className='col-lg-12 my-4 text-center'>
                                <p className='text-white f-72 my-5 f-pop-med'>My Profile</p>
                            </div>
                        </div>
                    </div>
                </section>
                <div className='container  my-5'>
                    <div className='row my-5'>
                        <div className='col-lg-12 my-5'>
                            <div className='card crd-edit-profile rounded-0'>
                                <div className='card-body p-5'>
                                    <div className='row'>
                                        <div className='col-lg-12'>
                                            <p className='f-pop-med f-35 mb-3'>Change Password</p>
                                        </div>
                                        <div className='col-lg-4 mt-4'>
                                            <input name="fname"
                                                type="text" placeholder='Current Password' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control'
                                            />
                                        </div>
                                        <div className='col-lg-4 mt-4'>
                                            <input
                                                name="lname"
                                                type="text" placeholder='New Password' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control' />
                                        </div>
                                        <div className='col-lg-4 mt-4'>
                                            <input
                                                name="phone"
                                                type="text" placeholder='Confirm Password ' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control' />
                                        </div>

                                        <div className='col-lg-12 text-end text-375-center-res-changepass mt-4'>
                                            <button onClick={() => { navigate('/myprofile') }} className='btn btn-danger bt-upload-basicinfo f-14 f-pop-med mt-3 '>Submit</button>
                                            <button onClick={() => { navigate('/myprofile') }} className='btn btn-secondary  clr-white-btn-edt border-0 f-14 f-pop-med mt-3 ms-3 ms-res-changepassword'>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default ChangePassword;